// src/components/const/enums.js
import { computed } from 'vue'
import i18n from '@/plugins/i18n' // tvoje existující i18n instance (cs/en + vuetify)

const t  = (k) => i18n.global.t(k)
const dep = () => i18n.global.locale.value // reaktivita na změnu jazyka

/* ------------------ DEFINICE (value z backendu -> i18n klíč) ------------------ */
const EVENT_TYPE_DEF = [
  { value:'races',       key:'enums.event_type.races' },
  { value:'camp',        key:'enums.event_type.camp' },
  { value:'practice',    key:'enums.event_type.practice' },
  { value:'other',       key:'enums.event_type.other' },
  { value:'repre',       key:'enums.event_type.repre' },
  { value:'scm',         key:'enums.event_type.scm' },
  { value:'association', key:'enums.event_type.association' },
]

const RACE_LEVEL_DEF = [
  { value:'INTERNATIONAL', key:'enums.race_level.INTERNATIONAL' },
  { value:'NATIONAL',      key:'enums.race_level.NATIONAL' },
  { value:'REGIONAL',      key:'enums.race_level.REGIONAL' },
  { value:'DISTRICT',      key:'enums.race_level.DISTRICT' },
  { value:'PRACTICE',      key:'enums.race_level.PRACTICE' },
  // { value:'SELECTIONS',    key:'enums.race_level.SELECTIONS' },
  { value:'OTHER',         key:'enums.race_level.OTHER' },
]

const RACE_TYPE_DEF = [
  { value:'CLASSIC',  key:'enums.race_type.CLASSIC' },
  { value:'SPRINT',   key:'enums.race_type.SPRINT' },
  { value:'FOXORING', key:'enums.race_type.FOXORING' },
  { value:'SHORT',    key:'enums.race_type.SHORT' },
  { value:'LONG',     key:'enums.race_type.LONG' },
  { value:'RELAY',    key:'enums.race_type.RELAY' },
]

const START_CHOICE_DEF = [
  { value:'',  key:'enums.start_choice.none' },
  { value:'0', key:'enums.start_choice.0' },
  { value:'1', key:'enums.start_choice.1' },
  { value:'2', key:'enums.start_choice.2' },
  { value:'3', key:'enums.start_choice.3' },
  { value:'4', key:'enums.start_choice.4' },
]

const GENDER_DEF = [
  { value:'M', key:'enums.gender.M' },
  { value:'F', key:'enums.gender.F' },
]

// const CATEGORY_TYPE_DEF = [
//   { value:'W07',  key:'enums.category_type.W07'  },
//   { value:'W09',  key:'enums.category_type.W09'  },
//   { value:'W12', key:'enums.category_type.W12' },
//   { value:'W14', key:'enums.category_type.W14' },
//   { value:'W16', key:'enums.category_type.W16' },
//   { value:'W19', key:'enums.category_type.W19' },
//   { value:'W21', key:'enums.category_type.W21' },
//   { value:'W35', key:'enums.category_type.W35' },
//   { value:'W45', key:'enums.category_type.W45' },
//   { value:'W55', key:'enums.category_type.W55' },
//   { value:'W65', key:'enums.category_type.W65' },
//   { value:'M07',  key:'enums.category_type.M07'  },
//   { value:'M09',  key:'enums.category_type.M09'  },
//   { value:'M12', key:'enums.category_type.M12' },
//   { value:'M14', key:'enums.category_type.M14' },
//   { value:'M16', key:'enums.category_type.M16' },
//   { value:'M19', key:'enums.category_type.M19' },
//   { value:'M21', key:'enums.category_type.M21' },
//   { value:'M40', key:'enums.category_type.M40' },
//   { value:'M50', key:'enums.category_type.M50' },
//   { value:'M60', key:'enums.category_type.M60' },
//   { value:'M70', key:'enums.category_type.M70' },
//   { value:'MDR', key:'enums.category_type.MDR' },
//   { value:'OTHERS', key:'enums.category_type.OTHERS' },
//   { value:'ORG',    key:'enums.category_type.ORG' },
// ]

const CATEGORY_RACE_TYPE_DEF = [
  { value:'CLASSIC', key:'enums.category_race_type.CLASSIC' },
  { value:'SPRINT',  key:'enums.category_race_type.SPRINT' },
  { value:'FOXORING',key:'enums.category_race_type.FOXORING' },
  { value:'LONG',    key:'enums.category_race_type.LONG' },
  { value:'RELAY',   key:'enums.category_race_type.RELAY' },
]

const CLUB_TYPE_DEF = [
  { value:'CLUB',    key:'enums.club_type.CLUB' },
  { value:'REPRE',   key:'enums.club_type.REPRE' },
  { value:'SCM',     key:'enums.club_type.SCM' },
  { value:'MASTERS', key:'enums.club_type.MASTERS' },
]

const ROLE_TYPE_DEF = [
  { value:'referee', key:'enums.role_type.referee' },
  { value:'coach',   key:'enums.role_type.coach' },
  { value:'member',  key:'enums.role_type.member' },
]

// --- CURRENCY (code + flag + symbol) ---
export const CURRENCY_DEF = [
  { value:'CZK', symbol:'Kč',  flag:'🇨🇿' },
  { value:'EUR', symbol:'€',   flag:'🇪🇺' },
  { value:'USD', symbol:'$',   flag:'🇺🇸' },
  { value:'PLN', symbol:'zł',  flag:'🇵🇱' },
  { value:'HUF', symbol:'Ft',  flag:'🇭🇺' },
  { value:'RON', symbol:'lei', flag:'🇷🇴' },
  { value:'GBP', symbol:'£',   flag:'🇬🇧' },
  { value:'SEK', symbol:'kr',  flag:'🇸🇪' },
  { value:'NOK', symbol:'kr',  flag:'🇳🇴' },
  { value:'DKK', symbol:'kr',  flag:'🇩🇰' },
  { value:'CHF', symbol:'Fr',  flag:'🇨🇭' },
  { value:'AUD', symbol:'A$',  flag:'🇦🇺' },
  { value:'CAD', symbol:'C$',  flag:'🇨🇦' },
  { value:'JPY', symbol:'¥',   flag:'🇯🇵' },
  { value:'CNY', symbol:'¥',   flag:'🇨🇳' },
  { value:'INR', symbol:'₹',   flag:'🇮🇳' },
  { value:'RUB', symbol:'₽',   flag:'🇷🇺' },
  { value:'KRW', symbol:'₩',   flag:'🇰🇷' },
]


/* ------------------ HELPERY ------------------ */
const mapItems = (def) => {
  dep()
  return def.map(({ value, key }) => ({ value, title: t(key) }))
}
const toDict = (itemsRef) => computed(() => {
  dep()
  return Object.fromEntries(itemsRef.value.map(i => [i.value, i.title]))
})

/* ------------------ ITEMS pro <v-select> ------------------ */
export const EVENT_TYPE_ITEMS          = computed(() => mapItems(EVENT_TYPE_DEF))
export const RACE_LEVEL_ITEMS          = computed(() => mapItems(RACE_LEVEL_DEF))
export const RACE_TYPE_ITEMS           = computed(() => mapItems(RACE_TYPE_DEF))
export const START_CHOICE_ITEMS        = computed(() => mapItems(START_CHOICE_DEF))
export const GENDER_ITEMS              = computed(() => mapItems(GENDER_DEF))
// export const CATEGORY_TYPE_ITEMS       = computed(() => mapItems(CATEGORY_TYPE_DEF))
export const CATEGORY_RACE_TYPE_ITEMS  = computed(() => mapItems(CATEGORY_RACE_TYPE_DEF))
export const CLUB_TYPE_ITEMS           = computed(() => mapItems(CLUB_TYPE_DEF))
export const ROLE_TYPE_ITEMS           = computed(() => mapItems(ROLE_TYPE_DEF))
export const CURRENCY_ITEMS            = Object.freeze(CURRENCY_DEF.map(c => c.value))
export const CURRENCY_SYMBOL_MAP       = Object.fromEntries(CURRENCY_DEF.map(c => [c.value, c.symbol]))
// export const CURRENCY_FLAG_MAP         = Object.fromEntries(CURRENCY_DEF.map(c => [c.value, c.flag]))

/* ------------------ DICT pro {{ code -> label }} ------------------ */
export const EVENT_TYPE_DICT          = toDict(EVENT_TYPE_ITEMS)
export const RACE_LEVEL_DICT          = toDict(RACE_LEVEL_ITEMS)
export const RACE_TYPE_DICT           = toDict(RACE_TYPE_ITEMS)
export const START_CHOICE_DICT        = toDict(START_CHOICE_ITEMS)
export const GENDER_DICT              = toDict(GENDER_ITEMS)
// export const CATEGORY_TYPE_DICT       = toDict(CATEGORY_TYPE_ITEMS)
export const CATEGORY_RACE_TYPE_DICT  = toDict(CATEGORY_RACE_TYPE_ITEMS)
export const CLUB_TYPE_DICT           = toDict(CLUB_TYPE_ITEMS)
export const ROLE_TYPE_DICT           = toDict(ROLE_TYPE_ITEMS)

/* ------------------ label helpery (volitelné pro volání v kódu) ------------------ */
const label = (base, v) => (v == null || v === '') ? '' : t(`${base}.${v}`)
export const labelEventType        = (v) => label('enums.event_type', v)
export const labelRaceLevel        = (v) => label('enums.race_level', v)
export const labelRaceType         = (v) => label('enums.race_type', v)
export const labelGender           = (v) => label('enums.gender', v)
// export const labelCategoryType     = (v) => label('enums.category_type', v)
export const labelCategoryRaceType = (v) => label('enums.category_race_type', v)
export const labelClubType         = (v) => label('enums.club_type', v)
export const labelRoleType         = (v) => label('enums.role_type', v)
export const currencySymbol        = (code) => CURRENCY_SYMBOL_MAP[code] || code
// export const currencyFlag          = (code) => CURRENCY_FLAG_MAP[code]   || ''

/* ------------------ použití:
<v-select v-model="event.event_type" :items="EVENT_TYPE_ITEMS" item-title="title" item-value="value" />
{{ RACE_TYPE_DICT[race.race_type] }}

pro proměnné se vrátí podle enumu jejich popisek:
currencySymbol(event.event_currency) 
------------------ */
